import React from 'react';
import PropTypes from 'prop-types';
import { GlobalWidthSettingsCard } from '../cards';

/**
 * Body of the Global Width Settings modal — single card, but wrapped so the
 * dialog contract matches the rest of the style modals.
 */
const GlobalWidthSettingsModal = ({ value = {}, onChange, theme, t }) => (
    <GlobalWidthSettingsCard value={value} onChange={onChange} theme={theme} t={t} />
);

GlobalWidthSettingsModal.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default GlobalWidthSettingsModal;
